/**
 * The design-system popup row, pinned to the Figma spec at
 * https://www.figma.com/design/s5knlq42XjwZx88JuPw8c7/GTOW-Design-System?node-id=6266-88477
 *
 * Menu rows and listbox rows (Select, Combobox, Autocomplete) are the same
 * control at different call sites, so they share this base rather than each
 * restating it — the two used to drift, with listbox rows at 20px against Menu's
 * 28px. Menu layers its icon, selected and submenu states on top; a listbox row
 * has none of those, which is the whole of the difference.
 *
 * `shrink-0`: a row is a flex child of a height-capped scrollable list, and
 * without it overflow compresses every row instead of scrolling them.
 *
 * Base UI sets `data-highlighted` for pointer hover as well as keyboard
 * navigation, so one rule covers both states.
 */
export const popupRowStyles = [
  'relative flex h-7 w-full shrink-0 select-none items-center gap-2 rounded-sm px-2',
  'text-sm font-medium text-text-primary',
  'cursor-pointer outline-none',
  'data-[highlighted]:bg-states-hover',
  'data-[disabled]:cursor-not-allowed data-[disabled]:text-text-disabled',
  'data-[disabled]:data-[highlighted]:bg-transparent data-[disabled]:data-[highlighted]:text-text-disabled',
]
